import { ICreateTermoEPIUseCase } from "../../../presentation/useCases/create/create_termo_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class CreateTermoEPIUseCase implements ICreateTermoEPIUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {}

  async execute(
    codigo?: string,
    descricao?: string,
    nome?: string,
  ): Promise<number> {
    return this.repository.createTermoEPI(codigo, descricao, nome);
  }
}
